import { INLinkProps } from '@components/INLink/types'
import { useCurrentRoute } from '@data/store/slices/route/getters'
import Route, { RouterMethod } from '@routes/utils'
import { getRouterMethod } from '@routes/utils/getRouterMethod'
import { canCheckForContainerApp, isContainerApp } from '@util/device'

export function useRouterMethod(route?: INLinkProps['route']): RouterMethod | undefined {
    const currentRoute = useCurrentRoute()

    if (!(route instanceof Route)) {
        return
    }

    return getRouterMethod({
        currentRoute,
        nextRoute: route,
        isContainerApp: canCheckForContainerApp() && isContainerApp(),
    })
}
